var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.routeName === 'WebCall' && _vm.screenWidth >= 600 ? false : true)?_c('div',{staticClass:"corp-header--mobile"},[_c('v-toolbar-items',[_c('DropdownCompany'),_c('v-spacer'),_c('DropdownUser')],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }